/**
 * Statusmodell der Tickets (Spec 3.3) — als **reine Funktionen**, damit API,
 * Admin-UI und Tests dieselbe Wahrheit benutzen und die Matrix ohne Datenbank
 * pruefbar bleibt.
 *
 *   open → pending → waiting_customer → resolved → closed
 *
 * Zwei Automatismen haengen daran:
 *   - Antwort an den Kunden setzt `waiting_customer`
 *   - Kundenantwort auf `resolved`/`waiting_customer` reoeffnet (`open`)
 */
import { TICKET_STATUSES } from './schemas/ticket.js';
/**
 * Erlaubte Uebergaenge. Bewusst grosszuegig innerhalb der aktiven Zustaende —
 * ein Agent muss ein Ticket jederzeit zurueckstellen oder loesen koennen.
 *
 * Eng ist nur der Ausgang aus `closed`: von dort geht es ausschliesslich zurueck
 * nach `open` (Wiederaufnahme). Und `resolved` kann nicht nach
 * `waiting_customer` — „geloest" ist bereits die Mitteilung an den Kunden.
 */
export const TICKET_STATUS_TRANSITIONS = {
    open: ['pending', 'waiting_customer', 'resolved', 'closed'],
    pending: ['open', 'waiting_customer', 'resolved', 'closed'],
    waiting_customer: ['open', 'pending', 'resolved', 'closed'],
    resolved: ['open', 'pending', 'closed'],
    closed: ['open'],
};
/** Zustaende, in denen ein Ticket noch Arbeit bedeutet (Listen-Default im UI). */
export const OPEN_TICKET_STATUSES = [
    'open',
    'pending',
    'waiting_customer',
];
/**
 * Ist der Uebergang erlaubt? `from === to` ist **kein** Uebergang und damit
 * `false` — der aufrufende Service behandelt den Gleichstand als No-op,
 * nicht als Fehler.
 */
export function canTransition(from, to) {
    return TICKET_STATUS_TRANSITIONS[from].includes(to);
}
/** Alle Zielzustaende, die das UI anbieten darf. */
export function allowedTransitions(from) {
    return TICKET_STATUS_TRANSITIONS[from];
}
/**
 * Reopen-Regel (Spec 3.3): eine Kundenantwort auf `resolved` oder
 * `waiting_customer` setzt das Ticket zurueck auf `open`.
 *
 * `null` = Status bleibt, wie er ist. `closed` ist bewusst **nicht** dabei:
 * ein abgeschlossener Vorgang wird nur von Hand wieder aufgemacht.
 */
export function statusAfterInboundMessage(current) {
    return current === 'resolved' || current === 'waiting_customer' ? 'open' : null;
}
/**
 * Antwort an den Kunden setzt `waiting_customer` (Spec 3.3). Aus `resolved`
 * und `closed` heraus passiert nichts — dort ist eine Nachricht ein Nachtrag,
 * kein Wiedereintritt in die Bearbeitung.
 */
export function statusAfterOutboundMessage(current) {
    return current === 'open' || current === 'pending' ? 'waiting_customer' : null;
}
/** Interne Notizen aendern nie den Status — explizit, damit es niemand rät. */
export function statusAfterInternalNote() {
    return null;
}
export function isTicketStatus(value) {
    return TICKET_STATUSES.includes(value);
}
//# sourceMappingURL=ticket-status.js.map